import { useContext } from 'react';
import {Navigate, Outlet} from 'react-router-dom'
import AuthContext from '../context/AuthContext';


const PrivateRoute = () => {
//   const isAuthenticated = true; // Replace with real auth logic
//   console.log('Private route working')
  let {user} =useContext(AuthContext)

  return user ? <Outlet /> : <Navigate to="login" />;
};

export default PrivateRoute;